import { useTranslation } from "react-i18next";

export function SupportPanel({ contacts }) {
  const { t } = useTranslation();
  if (contacts.length === 0) {
    return <div className="text-center py-12 bg-white rounded-2xl border border-border text-muted2 font-body">{t("dash.noMessages")}</div>;
  }
  return (
    <div className="space-y-3">
      {contacts.map((c) => (
        <div key={c.id} className="bg-white rounded-2xl shadow-card border border-border p-4">
          <div className="flex justify-between"><p className="font-heading font-bold text-ink">{c.subject}</p><span className="text-xs text-muted2">{c.name} · {c.email}</span></div>
          <p className="text-muted2 font-body text-sm mt-1">{c.message}</p>
        </div>
      ))}
    </div>
  );
}
